/*
 * ET - Footer (sections/et-footer.liquid)
 * Mobile accordions for the link columns: one delegated click listener, so sections re-rendered by the theme editor
 * work without re-initialising. Selecting a "Links" block in the editor opens its accordion. When the column wrapper
 * carries data-et-footer-single ("Close other columns when one opens"), opening a column closes the others.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  if (root.hasAttribute('data-et-footer-ready')) return;
  root.setAttribute('data-et-footer-ready', '');

  var MENU_SELECTOR = '[data-et-footer-menu]';
  var TOGGLE_SELECTOR = '[data-et-footer-toggle]';
  var SINGLE_SELECTOR = '[data-et-footer-single]';
  var OPEN_CLASS = 'is-open';

  function setOpen(menu, open) {
    var toggle = menu.querySelector(TOGGLE_SELECTOR);
    menu.classList.toggle(OPEN_CLASS, open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeOthers(menu) {
    var group = menu.closest(SINGLE_SELECTOR);
    if (!group) return;
    group.querySelectorAll(MENU_SELECTOR).forEach(function (other) {
      if (other !== menu && other.classList.contains(OPEN_CLASS)) setOpen(other, false);
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest(TOGGLE_SELECTOR);
    if (!toggle) return;

    var menu = toggle.closest(MENU_SELECTOR);
    if (!menu) return;

    event.preventDefault();
    var open = !menu.classList.contains(OPEN_CLASS);
    if (open) closeOthers(menu);
    setOpen(menu, open);
  });

  // A re-rendered section starts from its server state: keep aria-expanded in step with the rendered classes.
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll(MENU_SELECTOR).forEach(function (menu) {
      setOpen(menu, menu.classList.contains(OPEN_CLASS));
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var menu = event.target;
    if (!menu || !menu.matches || !menu.matches(MENU_SELECTOR)) return;
    closeOthers(menu);
    setOpen(menu, true);
  });
})();
